import React from 'react'
import { ContentImage, ContentImageProps } from './ContentImage'
import { ContentText, ContentTextProps } from './ContentText'

export interface ISection {
    imageProps: ContentImageProps
    textProps: ContentTextProps
    reverse?: boolean
    className?: string
}

export const Section: React.FC<ISection> = ({
    imageProps,
    textProps,
    reverse = false,
    className = '',
}) => {
    const gridCols = reverse
        ? 'lg:grid-cols-[2fr_3fr]'
        : 'lg:grid-cols-[3fr_2fr]'

    const textElement = (
        <div
            className={`flex h-full min-w-0 items-center justify-center ${
                reverse ? 'lg:order-1' : 'lg:order-2'
            }`}
        >
            <div className="w-full max-w-full">
                <ContentText
                    {...textProps}
                    className="w-full max-w-full break-words"
                    titleClassName="text-heading-5 capitalize"
                />
            </div>
        </div>
    )
    const imageElement = (
        <div
            className={`flex h-full min-w-0 items-center justify-center ${
                reverse ? 'lg:order-2' : 'lg:order-1'
            }`}
        >
            <ContentImage
                {...imageProps}
                className="h-full w-full object-contain"
                containerClassName={imageProps.className}
            />
        </div>
    )

    return (
        <div
            className={`mx-auto grid w-full max-w-[1680px] grid-cols-1 items-center gap-0 sm:gap-12 ${gridCols} h-auto lg:h-[504px] ${className}`}
            data-testid="premium-overview-section"
        >
            {textElement}
            {imageElement}
        </div>
    )
}
